import { captureLegacyEvent } from "../analytics/events";
import { User } from "../store/pomeriumApi";

/*
to get user:
const { user } = useContext(UserContext);
passed in because of error when using these within a useEffect which we will need to do
 */
const sendStandardEvent = (
  name: string,
  type: string,
  user: User | undefined,
  additionalAttributes?: { [key: string]: any },
) => {
  captureLegacyEvent(name, type, user, additionalAttributes);
};

export default sendStandardEvent;
